import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './reset.css';
import { unregister as unregisterServiceWorker } from 'libraries/registerServiceWorker';

import route from 'route';
import Home from 'screens/Home';
import Privacy from 'screens/Privacy';

import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import Reducers from 'reducers';
//import Cookies from 'libraries/cookies';
import { ParallaxProvider } from 'react-scroll-parallax';

import 'react-tippy/dist/tippy.css';
import Thanks from 'screens/Thanks';

// const PrivateRoute = ({ component: Component, ...rest }) => (
// 	<Route
// 		{...rest}
// 		render={props =>
// 			Cookies.getToken() !== undefined || true ? (
// 				<Component {...props} />
// 			) : (
// 				<Redirect to="/login" />
// 			)
// 		}
// 	/>
// );

ReactDOM.render(
	<ParallaxProvider>
		<div className='app'>
			<Reducers>
				<BrowserRouter>
					<Switch>
						<Route path={route('home')} component={Home} />
						<Route path={route('privacy')} component={Privacy} />
						<Route path={route('thanks')} component={Thanks} />
						<Redirect to={route('home')} />
					</Switch>
				</BrowserRouter>
			</Reducers>
		</div>
	</ParallaxProvider>,
	document.getElementById('root')
);
unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js